import React from "react";
import "./Contact.css";

const Contact = ({ therapists }) => {
  return (
    <div className="contactContainer">
      <p className="contactHeader">Contact Us</p>
      <p className="contactIntro">
        To contact a therapist, please select the therapist you wish to contact
        from one of the lists below. If you need to mail something to a specific
        therapist, please include your therapist's name on the address so you
        mail can be routed to the correct therapist.
      </p>
      <div className="contactDetails">
        <div className="contactPhone">
          <p className="contactSubHeader">Phone:</p>
          {therapists.map((therapist) => (
            <li>
              {therapist.FirstName} {therapist.LastName}: {therapist.Phone}
            </li>
          ))}
        </div>
        <div className="contactEmail">
          <p className="contactSubHeader">Email:</p>
          {therapists.map((therapist) => (
            <li>
              {therapist.FirstName} {therapist.LastName}: {therapist.Email}
            </li>
          ))}
        </div>
        <div className="contactMail">
          <p className="contactSubHeader">Mail:</p>

          <p>Counseling and Psychotherapy Associates of Georgia</p>
          <p>Attn: &lt;therapist's name&gt;</p>
          <p>2070 Buford Hwy</p>
          <p>Suite 1B</p>
          <p>Buford, GA 30518</p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
